// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607091033/js/" + chunkId + "." + {"44":"a98129da","225":"174de050","481":"b1d51c6f","486":"b282d1ee","770":"e30e6fe8"}[chunkId] + ".0.7969839885261475.chunk.js";
};